(function() {
    'use strict';

    angular.module('product')
        .controller('ExclusionListController', ExclusionListController);

    ExclusionListController.$inject = ['$state', 'productOptionExclusionDataSrvc', 'productOptionExclusionSrvc', 'notificationSrvc', 'exclusionMessagesConst', 'lodashService', 'exclusionPermissionsConst', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'filterQuerySrvc'];

    function ExclusionListController($state, productOptionExclusionDataSrvc, productOptionExclusionSrvc, notificationSrvc, exclusionMessagesConst, lodashService, exclusionPermissionsConst, datatableDefaultPageSizeValueConst, checkSearchSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.exclusionRows = [];
        self.exclusionCols = [{
            title: 'ID #1',
            value: 'option_1.pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa #1',
            value: 'option_1.label_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis #1',
            value: 'option_1.description_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'ID #2',
            value: 'option_2.pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa #2',
            value: 'option_2.label_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis #2',
            value: 'option_2.description_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = exclusionPermissionsConst;

        self.searchQuery = {
            'option_1.pk': null,
            'option_1.label_pl': null,
            'option_1.description_pl': null,
            'option_2.pk': null,
            'option_2.label_pl': null,
            'option_2.description_pl': null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getExclusiuons();
        }

        function getExclusiuons(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    option_1_pk: self.searchQuery['option_1.pk'],
                    option_1_label_pl: self.searchQuery['option_1.label_pl'],
                    option_1_description_pl: self.searchQuery['option_1.description_pl'],
                    option_2_pk: self.searchQuery['option_2.pk'],
                    option_2_label_pl: self.searchQuery['option_2.label_pl'],
                    option_2_description_pl: self.searchQuery['option_2.description_pl'],
                    ordering: self.searchQuery.ordering
                };
            }
            return productOptionExclusionDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.exclusionRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getExclusiuons);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.productOptionExclusion.create');
        }

        function onEdit(row) {
            $state.go('layout.productOptionExclusion.update', { pk: row.pk });
        }

        function onDelete(row) {
            return productOptionExclusionSrvc.remove(row.option_1.label + ' - ' + row.option_2.label, row.pk, function(response) {
                notificationSrvc.notification("success", exclusionMessagesConst.delete);
                lodashService.remove(self.exclusionRows, { pk: row.pk });
                return response;
            }, function(error) {
                notificationSrvc.notification("error", error.data.detail);
            });
        }

        function onReorder(row, newPos) {
            return productOptionExclusionDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getExclusiuons();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getExclusiuons();
        }
    }
})();
